// Desactivar temporalmente hasta que el sistema de denuncia de siniestros esté operativo
export const SHOW_DENUNCIA_SINIESTROS = false;
